export default __webpack_public_path__ + "static/media/bihada-factory-profile-ikumi.1d6ad44d.png";